import { store } from '../../../index'

import { fetchAssignedUsersSuccess } from '../../assignedUsers'

const { dispatch, getState } = store

/**
 * Add new conversation assigned
 * @param {object} event
 * @param {object} event.payload
 * @param {object} event.payload.conversation New conversation assigned
 *
 * @returns {boolean}
 */
export const addNewAssignation = (event) => {
  const conversations = getState()?.assignedUsers?.users || []
  const { conversation } = event.payload

  dispatch(fetchAssignedUsersSuccess([conversation].concat(conversations)))

  return true
}

/**
 * Remove conversation assigned
 * @param {object} event
 * @param {object} event.payload
 * @param {object} event.payload.conversation assigned conversation deleted
 *
 * @returns {boolean}
 */
export const removeAssignation = (event) => {
  const conversations = getState()?.assignedUsers?.users || []
  const { conversation } = event.payload

  const size = conversations.length
  const listAssigned = conversations.filter((conv) => conv.id !== conversation.id)

  if (size !== listAssigned.length) {
    dispatch(fetchAssignedUsersSuccess(listAssigned))
  }

  return true
}
